var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.581 2.66797C17.186 2.66797 12.0021 7.85186 12.0021 14.2469C12.0021 20.642 17.186 25.8259 23.581 25.8259C29.9761 25.8259 35.16 20.642 35.16 14.2469C35.16 7.85186 29.9761 2.66797 23.581 2.66797ZM9.97574 27.9311C8.6708 27.9311 7.41928 28.4494 6.49644 29.3721C5.5736 30.2947 5.05499 31.5461 5.05469 32.851V33.7206C5.05469 38.0685 7.30332 41.3245 10.7515 43.4238C14.1442 45.4883 18.7016 46.4574 23.581 46.4574C28.4604 46.4574 33.0178 45.4883 36.4105 43.4238C39.8587 41.3245 42.1073 38.0685 42.1073 33.7206V32.851C42.1073 32.2048 41.98 31.565 41.7327 30.968C41.4854 30.371 41.1229 29.8286 40.6659 29.3717C40.2089 28.9149 39.6664 28.5525 39.0694 28.3053C38.4723 28.0581 37.8325 27.931 37.1863 27.9311H9.97574Z",
    fill: "#ABE138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.17122a31c4fee0c789b7a16504a80143.svg";
export { ForwardRef as ReactComponent };